var React = require('react');

function BagActiveInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"8","width":"20.5","height":"16","fill":"currentColor","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M7.03125 7V4.27273C7.03125 2.46525 8.92005 1 11.25 1C13.58 1 15.4688 2.46525 15.4688 4.27273V7","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

BagActiveInline.defaultProps = {"width":"23","height":"25","viewBox":"0 0 23 25","fill":"none"};

module.exports = BagActiveInline;

BagActiveInline.default = BagActiveInline;
